import type { DrawDeadlineConfig, GameConfig } from '@/config/game';
import { deadlinesDrawToDrawDays } from '@/helpers/deadlinesDrawToDrawDays';
import drawRangeDate from '@/helpers/drawRangeDate';

export const GameSummaryDrawDays = ({
  games,
  selectedWeeksNumber,
  selectedDrawDays,
  selectedWeeklySubscription,
}: {
  games?: GameConfig[];
  selectedWeeksNumber: number;
  selectedDrawDays?: string[];
  selectedWeeklySubscription?: boolean;
}) => {
  return (
    <div className="GameSummaryDrawDays p">
      {selectedDrawDays && selectedWeeklySubscription
        ? selectedDrawDays.join(' und ')
        : !games
        ? null
        : games
            .reduce(
              (
                prev: Array<{
                  title: string;
                  drawDeadlines: readonly DrawDeadlineConfig[] | undefined;
                  drawDays: string[];
                }>,
                current: GameConfig,
                index: number
              ) => {
                const { title, drawDeadlines } = current;
                const drawDays =
                  (drawDeadlines && deadlinesDrawToDrawDays(drawDeadlines)) ||
                  [];
                const same = prev.find(
                  (i) =>
                    i.drawDays.length < drawDays.length ||
                    JSON.stringify(i.drawDeadlines) ===
                      JSON.stringify(drawDeadlines) ||
                    JSON.stringify(drawDays) === JSON.stringify(i.drawDays)
                );
                if (title) {
                  if (index === 0 || !same) {
                    prev.push({
                      title,
                      drawDeadlines,
                      drawDays:
                        index === 0 && selectedDrawDays
                          ? selectedDrawDays
                          : drawDays,
                    });
                  } else {
                    prev[prev.indexOf(same)].title += ', ' + current.title;
                  }
                }
                return prev;
              },
              []
            )
            .map(
              (game, index, games) =>
                game.drawDays && (
                  <p key={index}>
                    {games.length > 1 && (
                      <strong className="GameSummaryDrawDays__title">
                        {game.title}
                      </strong>
                    )}

                    <>
                      {drawRangeDate(
                        selectedWeeksNumber,
                        game.drawDays,
                        game.drawDeadlines
                      ).map((date, index) => {
                        return (
                          <span className="GameSummary__draw-date" key={index}>
                            {new Intl.DateTimeFormat('de-De', {
                              dateStyle: 'full',
                              timeZone: 'Europe/Berlin',
                            }).format(date)}
                          </span>
                        );
                      })}
                    </>
                  </p>
                )
            )}
    </div>
  );
};
